import { Identificator } from './custom-types';
import { Adres } from './adres';
import { Slownik } from './slownik';
import { Plec } from '../enums/plec.enum';
import { RodzajDokumentu } from '../enums/rodzaj-dokumentu.enum';

export class CzlonekRodziny {
  id!: Identificator | null;
  imie!: string | null;
  drugieImie!: string | null;
  nazwisko!: string | null;
  pesel!: string | null;
  dataUrodzenia!: Date | null;
  plec!: Plec | null;
  rodzajDokumentu!: RodzajDokumentu | null;
  nrDokumentu!: string | null;
  obywatelstwo!: Slownik | null;
  stanCywilny!: Slownik | null;
  adres!: Adres | null;
  szkola!: CzlonekRodzinySzkola | null;
}

export class CzlonekRodzinySzkola {
  id?: Identificator | null;
  nazwa!: string | null;
  rodzaj!: Slownik | null;
  adres!: Adres | null;
}
